interface iEventItemLoadingProps {
  y: number;
}

function EventItemLoading({ y }: iEventItemLoadingProps) {
  const roundedProps = {
    rx: 4,
    ry: 4,
  };

  return (
    <>
      <rect y={y} width='74' height='63' {...roundedProps} />
      <rect y={y} x='90' width='50' height='18' {...roundedProps} />
      <rect y={y} x='144' width='46' height='18' {...roundedProps} />
      <rect y={y + 22} x='90' width='300' height='21' {...roundedProps} />
      <rect y={y + 47} x='90' width='90' height='16' {...roundedProps} />
    </>
  );
}

export { EventItemLoading };
